export default {
  filters: {
    formatNumber (value, fix) {
      if (value === undefined || value === null) {
        return ''
      }
      const fixed = (fix || fix === 0) ? Number(fix) : value % 1 === 0 ? 0 : 2

      return (
        value.toFixed(fixed).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      )
    },
    localeDate (dateStr) {
      return new Date(dateStr).toLocaleDateString()
    },
    formatDate (date, format = 'DD-MM-YYYY') {
      return (
        date.format(format)
      )
    },
    capitalize (text) {
      return text[0].toUpperCase() + text.substring(1).toLowerCase()
    },
    titleCase (text) {
      return text.split(' ')
        .map(text => text[0].toUpperCase() + text.substring(1).toLowerCase())
        .join(' ')
    }
  }
}
